module.exports = __webpack_public_path__ + "static/media/nav-logo.72cd4e60.svg";